export const SET_ACTIVE_TROUBLESHOOTER_ERRORCLASS = "SET_ACTIVE_TROUBLESHOOTER_ERRORCLASS"
export const SET_ACTIVE_TROUBLESHOOTER_ERRORCLASS_TEXT = "SET_ACTIVE_TROUBLESHOOTER_ERRORCLASS_TEXT"

export const GRAPHQL_REQUEST_ALL_ERROR_CLASSES = "GRAPHQL_REQUEST_ALL_ERROR_CLASSES"